import React from 'react'
import FilterEvents from '../Drive/Cards/FilterEvents'
import EventStreamContent from './EventStreamContent'
import { Image, List, } from 'semantic-ui-react';
import iconStream from '../../../../images/grafix-icon/icon-stream.svg'


class ActivityStream extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {

    }

    render() {
        const { loaderEventData, selectedOrganisation, notificationsCount, selectedAccount, initiativeOwnerDetails, filterQuery } = this.props
        return (
            <div>
                <div className="count-header " style={{ padding: '3px 0' }} >
                    <div className="float-left pad_5" style={{ margin: "3px 5px" }}>
                        <List verticalAlign='middle'>
                            <List.Item>
                                <Image src={iconStream} style={{ height: "14px" }} />
                                <List.Content>
                                    <List.Header>Event Stream </List.Header>
                                </List.Content>
                            </List.Item>
                        </List>
                    </div>
                    <div className="float-right " >
                        <FilterEvents
                            selectedOrganisation={selectedOrganisation}
                            selectedAccount={selectedAccount}
                            type="event-stream"
                            filterQuery={filterQuery}
                        />
                    </div>
                </div>
                <EventStreamContent
                    loaderEventData={loaderEventData}
                    eventStreamArray={this.props.eventStreamArray}
                    selectedOrganisation={selectedOrganisation}
                    notificationsCount={notificationsCount}
                    selectedAccount={selectedAccount}
                    initiativeOwnerDetails={initiativeOwnerDetails}
                    eventPage="home"
                    filterQuery={filterQuery}
                    noEventDataFound={this.props.noEventDataFound}
                    currentOrganization={this.props.currentOrganization}
                    user={this.props.user}
                    singlePlaybookEntry={this.props.singlePlaybookEntry}



                />
            </div>
        )
    }
}

export default ActivityStream;